<template>
  <!--[pageFooter]-->
  <div class="pageFooter" v-if="$slots.footer">
    <slot name="footer"></slot>
  </div>
  <!--[/pageFooter]-->
</template>

<script setup>
defineProps({
  pageName: {
    type: String,
  },
  pageNavs: {
    type: Array,
  },
});
</script>
